var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRadioGroup',{staticClass:"radio-groups",attrs:{"radios":_vm.list},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }